import { AppConfig } from '../typings';

export const appConfig: AppConfig = {
  apiBaseUrl: '/api',
  /* @ts-ignore */
  name: process.env.PKG_NAME,
  isNode: false,
  /* @ts-ignore */
  startApp: true,
  /* @ts-ignore */
  version: process.env.PKG_VERSION,
  /* @ts-ignore */
  env: { ...process.env },
};
